export default __webpack_public_path__ + "static/media/Course_material.6af73663.svg";